export default __webpack_public_path__ + "static/media/muscle-building.fba3e542.webp";